<div class="login-outer-box">
  <bcsc-digi-icon
    type="login-left-bottom"
    class="left-bottom-icon"
  ></bcsc-digi-icon>
  <div class="login-inner-box">
    <bcsc-digi-icon
      type="login-left-top"
      class="left-top-icon"
    ></bcsc-digi-icon>
    <bcsc-digi-icon
      type="login-right-bottom"
      class="right-bottom-icon"
    ></bcsc-digi-icon>
    <div class="login-box">
      <!-- SSO Login -->
      <div class="sso-box" *ngIf="isSSOLogin">
        <div class="big-circle"></div>
        <div class="square"></div>
        <div class="small-circle"></div>
        <div class="long-rect"></div>
        <div class="short-rect"></div>
        <div class="first-title">Welcome to</div>
        <img src="assets/Bosch.png" alt="Bosch" />
        <div class="second-title">- Login for employee -</div>
        <div class="desc">Login only works from Bosch network</div>
        <button
          nz-button
          nzType="primary"
          (click)="onLogin.emit({ login: true })"
        >
          Bosch Login
          <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
        </button>
      </div>
      <!-- common login -->
      <div class="common-box" *ngIf="!isSSOLogin">
        <div class="big-circle"></div>
        <div class="square"></div>
        <div class="small-circle"></div>
        <div class="long-rect"></div>
        <div class="short-rect"></div>
        <div class="first-title">{{ title }}</div>
        <div class="second-title">- Login for employee -</div>
        <form nz-form [formGroup]="validateModuleForm" class="login-form">
          <nz-form-item>
            <nz-form-control
              nzErrorTip="Please input your username"
              [nzSm]="24"
              [nzXs]="24"
            >
              <input
                nz-input
                formControlName="username"
                id="username"
                placeholder="Username"
              />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control
              nzErrorTip="Please input your password"
              [nzSm]="24"
              [nzXs]="24"
            >
              <input
                nz-input
                formControlName="password"
                id="password"
                placeholder="Password"
                [type]="displayPwd ? 'text' : 'password'"
              />
              <span
                nz-icon
                [nzType]="displayPwd ? 'eye' : 'eye-invisible'"
                nzTheme="outline"
                (click)="displayPwd = !displayPwd"
                class="pwd-icon"
              ></span>
            </nz-form-control>
          </nz-form-item>
        </form>
        <button nz-button nzType="primary" (click)="onUserLogin()">
          Bosch Login
          <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
        </button>
      </div>
    </div>
  </div>
</div>
